import { useEntitlements } from "@/hooks/useEntitlements";
import { usePermissionsMap } from "@/hooks/usePermissionsMap";

export type DaycareHotelMode = "both" | "daycare" | "hotel" | "none";
export interface DaycareHotelAccess {
  hasDaycare: boolean;
  hasHotel: boolean;
  mode: DaycareHotelMode;
  labelKey: "daycareHotel" | "daycare" | "hotel";
  isLoading: boolean;
}

export function useDaycareHotelAccess(): DaycareHotelAccess {
  const { data: entitlements, isLoading: isLoadingEntitlements } = useEntitlements();
  const { data: permissions, isLoading: isLoadingPermissions } = usePermissionsMap();
  const activeModules = entitlements?.activeModules ?? [];
  const hasDaycare = activeModules.includes("day_care") && permissions?.daycare?.view === true;
  const hasHotel = activeModules.includes("hotel") && permissions?.hotel?.view === true;
  const mode: DaycareHotelMode = hasDaycare && hasHotel ? "both" : hasDaycare ? "daycare" : hasHotel ? "hotel" : "none";
  return { hasDaycare, hasHotel, mode, labelKey: mode === "daycare" ? "daycare" : mode === "hotel" ? "hotel" : "daycareHotel", isLoading: isLoadingEntitlements || isLoadingPermissions };
}
